import { ARCHIVED_BOOLEAN_FILTERS } from '@/common/api/archivedTableFilters';

export const CAPACITY_SCHEME_FILTER_KEYS = [...ARCHIVED_BOOLEAN_FILTERS] as const;

export type CapacitySchemeFilterKey = (typeof CAPACITY_SCHEME_FILTER_KEYS)[number];
